module.exports = __webpack_public_path__ + "img/glass.89f5caa9.svg";